// extracted by extract-css-chunks-webpack-plugin
module.exports = {"nds-sup":"_1pUTap"};